import moment from "moment-timezone";

import { Weekday } from "../components/main-details/components/hours/types";

export const getDayFromDate = (date: moment.Moment | null): Weekday | null => {
  if (!date) {
    return null;
  }

  return date.locale("en").format("dddd").toLowerCase() as Weekday;
};
